if (!customElements.get('c-drawer')) {
  class DrawerElement extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
      this.init();
    }

    init() {
      // Get DOM elements
      this.overlay = this.querySelector('.drawer-overlay');
      this.panel = this.querySelector('.drawer-panel');
      this.closeBtn = this.querySelector('.close-btn');

      // Bind event listeners
      this.overlay?.addEventListener('click', () => this.close());
      this.closeBtn?.addEventListener('click', () => this.close());

      // Escape key handler
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.close();
        }
      });
    }

    open() {
      this.isOpen = true;
      this.overlay?.classList.add('active');
      this.panel?.classList.add('active');
      document.body.style.overflow = 'hidden';

      // Dispatch custom event
      this.dispatchEvent(new CustomEvent('drawer-opened'));
    }

    close() {
      this.isOpen = false;
      this.overlay?.classList.remove('active');
      this.panel?.classList.remove('active');
      document.body.style.overflow = '';

      // Dispatch custom event
      this.dispatchEvent(new CustomEvent('drawer-closed'));
    }

    toggle() {
      this.isOpen ? this.close() : this.open();
    }

    // Attribute change observer
    static get observedAttributes() {
      return ['theme', 'width', 'title'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'title') {
        const titleElement = this.querySelector('.drawer-title');
        if (titleElement) {
          titleElement.textContent = newValue;
        }
      }
    }
  }

  // Register the custom element
  customElements.define('c-drawer', DrawerElement);
}
